export default "__VITE_ASSET__9ca1d27b__"